export default __webpack_public_path__ + "static/media/our-process-teb-img-04.385f666e.jpg";